<fa-icon
  class="text-white"
  [size]="size"
  [icon]="['fas', 'basket-shopping']"
></fa-icon>
